import { render, staticRenderFns } from "./rule6.vue?vue&type=template&id=e77bd40a&scoped=true"
import script from "./rule6.vue?vue&type=script&lang=js"
export * from "./rule6.vue?vue&type=script&lang=js"
import style0 from "./rule6.vue?vue&type=style&index=0&id=e77bd40a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77bd40a",
  null
  
)

export default component.exports